import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import ActiveSettings from 'redux/ActiveSettings';

const useSettings = () => {
  const dispatch = useDispatch();
  const instancePermissions = useSelector(ActiveSettings.getInstancePermissions);
  const instanceRoles = useSelector(ActiveSettings.getInstanceRoles);
  const convertPPM = useSelector(ActiveSettings.getConvertPPM);
  const convertTemp = useSelector(ActiveSettings.getConvertTemp);
  const convertUnits = useSelector(ActiveSettings.getConvertUnits);
  const selectedOrg = useSelector(ActiveSettings.getActiveOrg);
  const activeDashView = useSelector(ActiveSettings.getDashboardView);
  const activeAdminView = useSelector(ActiveSettings.getAdminView);
  const currentUserPermissions = useSelector(ActiveSettings.getCurrentUserPermissions);
  const currentUserRoles = useSelector(ActiveSettings.getCurrentUserRoles);

  const isSuper = useSelector(ActiveSettings.getIsSuper);
  const isAdmin = useSelector(ActiveSettings.getIsAdmin);

  const fetchInstancePermissions = () => {
    if (!instancePermissions || instancePermissions?.length === 0) {
      dispatch(ActiveSettings.fetchInstancePermissions());
    }
  };

  const fetchInstanceRoles = () => {
    if (!instanceRoles || instanceRoles?.length === 0) {
      dispatch(ActiveSettings.fetchInstanceRoles());
    }
  };

  const setConvertPPM = useCallback(
    (t) => {
      dispatch(ActiveSettings.setConvertPPM(t));
    },
    [dispatch]
  );

  const setConvertTemp = useCallback(
    (t) => {
      dispatch(ActiveSettings.setConvertTemp(t));
    },
    [dispatch]
  );

  const setConvertUnits = useCallback(
    (t) => {
      dispatch(ActiveSettings.setConvertUnits(t));
    },
    [dispatch]
  );

  const setOrg = useCallback(
    (t) => {
      dispatch(ActiveSettings.setSelectedOrg(t));
    },
    [dispatch]
  );

  const setDashView = useCallback(
    (t) => {
      dispatch(ActiveSettings.setDashboardView(t));
    },
    [dispatch]
  );

  const setAdminView = useCallback(
    (t) => {
      dispatch(ActiveSettings.setAdminView(t));
    },
    [dispatch]
  );

  const setCurrentUserPermissions = (permissions) => {
    dispatch(ActiveSettings.setCurrentUserPermissions(permissions));
  };

  const setCurrentUserRoles = (roles) => {
    dispatch(ActiveSettings.setCurrentUserRoles(roles));
  };

  return {
    instancePermissions,
    fetchInstancePermissions,
    instanceRoles,
    fetchInstanceRoles,
    setConvertPPM,
    setConvertTemp,
    setConvertUnits,
    convertPPM,
    convertTemp,
    convertUnits,
    selectedOrg,
    setOrg,
    setDashView,
    setAdminView,
    activeDashView,
    activeAdminView,
    currentUserPermissions,
    currentUserRoles,
    setCurrentUserPermissions,
    setCurrentUserRoles,
    isSuper,
    isAdmin,
  };
};

export default useSettings;
